// Pure Bamboo - Free Gift Logic (v7 - fix 400 con /cart/update.js)
const GIFT_TOTE = 57818399015295;
const GIFT_NECESER = 57818401112447;
const GIFT_HANDLES = ['neceser', 'tote-bag'];
const TOTE_HANDLES = ['bamboo-towel', 'toalla-mano'];
const NECESER_HANDLES = ['toalla-cara'];
const BOTH_HANDLES = ['pure-bamboo-signature-set-facial-manos-bano'];

const nativeFetch = window.fetch.bind(window);
const LOG = (...a) => console.log('%c[GIFT]', 'color:#0a0', ...a);

async function getCart() {
  const res = await nativeFetch('/cart.js');
  return res.json();
}
async function setQty(variantId, qty) {
  LOG('setQty', variantId, '->', qty);
  await nativeFetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: { [variantId]: qty } })
  });
}
async function addGift(variantId) {
  LOG('addGift', variantId);
  await nativeFetch('/cart/add.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });
}

async function refreshCartUI() {
  LOG('refreshCartUI (section correcta)');
  try {
    const cartComp = document.querySelector('cart-items-component');
    const sectionId = cartComp ? cartComp.dataset.sectionId : null;
    if (!sectionId) { LOG('no hay cart-items-component'); return; }
    const res = await nativeFetch(location.pathname + '?sections=' + sectionId);
    const data = await res.json();
    const freshHTML = data[sectionId];
    if (!freshHTML) { LOG('section vacía:', sectionId); return; }
    const parsed = new DOMParser().parseFromString(freshHTML, 'text/html');
    document.querySelectorAll('cart-items-component').forEach(current => {
      const fresh = parsed.querySelector('cart-items-component');
      if (fresh) { current.innerHTML = fresh.innerHTML; LOG('carrito repintado'); }
    });
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { source: 'free-gift', data: { sections: data } }
    }));
  } catch (e) { LOG('refreshCartUI ERROR', e); }
}

let isRunning = false;
let rerun = false;

async function updateGifts() {
  if (isRunning) { rerun = true; LOG('updateGifts ocupado, encolo'); return; }
  isRunning = true;
  let changed = false;
  try {
    const cart = await getCart();
    const items = cart.items;
    LOG('carrito:', items.map(i => `${i.handle} x${i.quantity}`));

    let needsTote = false, needsNeceser = false;
    for (const item of items) {
      if (item.variant_id === GIFT_TOTE || item.variant_id === GIFT_NECESER) continue;
      const h = item.handle;
      if (BOTH_HANDLES.includes(h)) { needsTote = true; needsNeceser = true; }
      if (TOTE_HANDLES.includes(h)) { needsTote = true; }
      if (NECESER_HANDLES.includes(h)) { needsNeceser = true; }
    }

    const toteItem = items.find(i => i.variant_id === GIFT_TOTE);
    const neceserItem = items.find(i => i.variant_id === GIFT_NECESER);
    const hasTote = !!toteItem, hasNeceser = !!neceserItem;
    LOG('needsTote', needsTote, 'hasTote', hasTote, '| needsNeceser', needsNeceser, 'hasNeceser', hasNeceser);

    if (needsTote && !hasTote) { await addGift(GIFT_TOTE); changed = true; }
    else if (needsTote && toteItem && toteItem.quantity > 1) { await setQty(GIFT_TOTE, 1); changed = true; }
    else if (!needsTote && hasTote) { LOG('EXPULSANDO tote huérfano'); await setQty(GIFT_TOTE, 0); changed = true; }

    if (needsNeceser && !hasNeceser) { await addGift(GIFT_NECESER); changed = true; }
    else if (needsNeceser && neceserItem && neceserItem.quantity > 1) { await setQty(GIFT_NECESER, 1); changed = true; }
    else if (!needsNeceser && hasNeceser) { LOG('EXPULSANDO neceser huérfano'); await setQty(GIFT_NECESER, 0); changed = true; }

    LOG('changed?', changed);
    if (changed) { await refreshCartUI(); }
  } catch (e) { LOG('updateGifts ERROR', e); }
  finally {
    isRunning = false;
    if (rerun) { rerun = false; scheduleUpdate(50); }
  }
}

let debounceTimer;
function scheduleUpdate(delay = 350) {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(updateGifts, delay);
}

document.addEventListener('click', function(e) {
  const a = e.target.closest('a[href*="/products/"]');
  if (!a) return;
  let path;
  try { path = new URL(a.href, window.location.origin).pathname; } catch (err) { return; }
  const match = path.match(/\/products\/([^\/]+)\/?$/);
  if (match && GIFT_HANDLES.includes(match[1])) {
    LOG('clic en regalo bloqueado:', match[1]);
    e.preventDefault(); e.stopPropagation(); return false;
  }
}, true);

document.addEventListener('DOMContentLoaded', () => {
  LOG('cargado. Interceptores activos.');
  scheduleUpdate(200);

  window.fetch = async function(...args) {
    const response = await nativeFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
      LOG('fetch detectado:', url);
      scheduleUpdate();
    }
    return response;
  };

  const originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this._giftUrl = url;
    return originalXHROpen.call(this, method, url, ...rest);
  };
  const originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(...sendArgs) {
    this.addEventListener('load', function() {
      const url = this._giftUrl || '';
      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
        LOG('XHR detectado:', url);
        scheduleUpdate();
      }
    });
    return originalXHRSend.apply(this, sendArgs);
  };

  const cartEvents = ['cart:updated', 'cart:refresh', 'cart:change', 'cart:item-removed', 'on:cart:update'];
  cartEvents.forEach(name => {
    document.addEventListener(name, () => { LOG('evento:', name); scheduleUpdate(400); });
  });

  const drawer = document.querySelector('.cart-drawer');
  if (drawer) {
    LOG('observador de drawer activo');
    let drawerTimer;
    const obs = new MutationObserver(() => {
      if (isRunning) return;
      clearTimeout(drawerTimer);
      drawerTimer = setTimeout(() => { LOG('drawer mutó, reviso'); scheduleUpdate(300); }, 250);
    });
    obs.observe(drawer, { childList: true, subtree: true });
  } else {
    LOG('OJO: no encontré .cart-drawer al cargar');
  }
});